import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverBlockFilterEntity } from '../../domain/entities/DriverBlockFilterEntity'

export class DriverBlockFilterModel extends DriverBlockFilterEntity {
  driverId?: number
  blockedByUserId?: string 
  regionId?: number

  constructor(dataDto: DriverBlockFilterEntity) {
    super()
    mapEntityProperties<DriverBlockFilterModel>(this, dataDto, {
      exclude: ['driver', 'region' ,'blockedByUser'],
      map: {
        driverId: dataDto.driver?.id,
        blockedByUserId: dataDto.blockedByUser?.id,
        regionId: dataDto.region?.id,
       }
    })
  }
}
